import { rest } from 'msw';

import { getApiEndpoint } from '../../utils/baseUrls';
import { withScenario, withAuthCheck } from '../../utils/middleware';
import { mockResponse } from '../../utils/responseResult';
import apiResponses from './happyGo.json';

const queryHappyGoInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['happyGoController/queryHappyGoInfo'].success.default)));
};

const queryHappyGoRedamption = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['happyGoController/queryHappyGoRedamption'].success.default)));
};
const queryRecordList = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['happyGoController/queryRecordList'].success.default)));
};
const queryPaymentInfo = (req, res, ctx) => {
  return res(ctx.json(mockResponse(apiResponses['happyGoController/queryPaymentInfo'].success.default)));
};

export const handlers = [
  rest.post(getApiEndpoint('happyGoController/queryHappyGoInfo'), withScenario(withAuthCheck(queryHappyGoInfo))),
  rest.post(
    getApiEndpoint('happyGoController/queryHappyGoRedamption'),
    withScenario(withAuthCheck(queryHappyGoRedamption))
  ),
  rest.post(getApiEndpoint('happyGoController/queryRecordList'), withScenario(withAuthCheck(queryRecordList))),
  rest.post(getApiEndpoint('happyGoController/queryPaymentInfo'), withScenario(withAuthCheck(queryPaymentInfo))),
];
